import React from 'react';
import { SearchIcon } from '@primer/octicons-react';
import { TextInput } from '@primer/react';

const IconWrapper = () => (
  <div className="py-1">
    <SearchIcon />
  </div>
)

const SHADOW_STYLE = {
  boxShadow: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)'
};

export const SearchInput = ({
  value,
  onChange,
  className,
  ariaLabel = 'Search',
  placeholder = 'Search',
  block = false,
  shadow = true,
  hideBorder = false,
}) => {
  const sx = shadow ? SHADOW_STYLE : {};
  if (hideBorder) {
    sx.borderStyle = 'none';
  }
  return (
    <TextInput
      className={className}
      sx={sx}
      value={value}
      onChange={onChange}
      leadingVisual={IconWrapper}
      aria-label={ariaLabel}
      placeholder={placeholder}
      block={block}
    />
  )
}

export default SearchInput;
